// ===========================================================================
// CUSTOMER ORDER HISTORY
// ===========================================================================
(function () {

  // Se mi trovo nella pagina dello storico ordini
  if ($('#order-history').length) {

    // Funzione di carico degli articoli nella lista dello storico ordini
    // (Anteprima articoli nella lista) e gestione dei pulanti di azione ordine
    $('.order-item').each(function () {

      // cache
      const $orderitem = $(this);

      // Stato dell'ordine
      const orderStatus = $orderitem.find('.order-status').text().trim();

      // Mostro o nascondo i pulsanti a seconda dello status dell'ordine
      if (orderStatus === 'ANNULLATO') {
        $orderitem.find('.button-req-return').removeClass('button-tech').prop('disabled', true).addClass('button-disabled');
        $orderitem.find('.button-mod-address').removeClass('button-tech').prop('disabled', true).addClass('button-disabled');
        $orderitem.find('.button-primary').removeClass('button-primary').removeAttr('href').addClass('button-disabled');

      } else if (orderStatus === 'CONCLUSO') {
        $orderitem.find('.button-mod-address').removeClass('button-tech').prop('disabled', true).addClass('button-disabled');

      } else if (orderStatus === 'SPEDITO') {
        $orderitem.find('.button-mod-address').removeClass('button-tech').prop('disabled', true).addClass('button-disabled');
        $orderitem.find('.button-primary').removeClass('button-primary').removeAttr('href').addClass('button-disabled');

      } else {
        $orderitem.find('.button-primary').removeClass('button-primary').removeAttr('href').addClass('button-disabled');

      }

      // Prendo il numero di documento web
      const numerodoc = $orderitem.find('input[name="documenti_testa_ID"]').val().trim();

      // Preparo i dati per la chiamata
      // manda=giusto serve per includere solo una parte del body nella risposta
      // alla chiamata in sostituzione dell'intero body+template per velocizzare
      // i tempi di caricamento (fondamentale)
      const dataToPost = 'manda=giusto&action=show&documenti_testa_ID=' + numerodoc + '';

      // Eseguo la chiamata e prendo la lista degli articoli presenti nell'ordine,
      // di cui mostro solo la parte definita dal div .cart-section-aj nel file
      // CustomerOrdersHistory_body.php
      $.ajax({
        type: 'POST',
        url: '../secure/CustomerOrdersHistory.php',
        data: dataToPost,
        success: function (data) {
          $orderitem.find('.content-test-up').append($(data).find('.cart-section-aj'));
          $('.cart-section-aj').addClass('row'); // Fix problemi layout
        }
      });
    });

  }

}());
